// extracted by mini-css-extract-plugin
module.exports = {"error":"e500_error__31KsG","text1":"e500_text1__-ZjP_"};